import constants from "../../constants";
import vbOutgoingDocUserViewService from "../../services/vbOutgoingDocUserViewService";
import vbAttachmentTokenMixin from "../../mixins/vbAttachmentTokenMixin";
import buildAttachmentURL from "../../filters/buildAttachmentURL.js";
import utils from "../../services/utils";

export default {
  mixins: [vbAttachmentTokenMixin],
  filters: {buildAttachmentURL},

  props: ["sort", "order", "advanceSearchForm"],
  data() {
    return {
      ATTACHMENT_OBJECT_TYPE: constants.ATTACHMENT_OBJECT_TYPE,
      outgoingDocs: [],
      outgoingDocsCount: null,
      page: 0,
      size: 10,
      perfectScrollbarSetting: {
        maxScrollbarLength: 250
      }
    };
  },

  methods: {
    deleteDoc(item) {
      this.$emit("deleteDoc", item);
    },

    doSort(sort) {
      let order =
        sort == this.sort ? (this.order == "asc" ? "desc" : "asc") : "asc";
      this.$emit("doSort", {order: order, sort: sort});
    },

    // countList: function () {
    //   vbOutgoingDocUserViewService
    //     .count(this.usingAdvanceSearch, this.keyword, this.status, this.advanceSearchForm, this.docStatus, this.fromCreateTime, this.toCreateTime)
    //     .then(response => {
    //       this.outgoingDocsCount = response.data;
    //     });
    // },

    doSearch() {
      this.outgoingDocs = [];
      this.page = 0;
      // this.countList();
      this.$refs.infiniteLoading.stateChanger.reset();
    },

    list() {
      // console.log(JSON.stringify(this.advanceSearchForm));
      let pageable = {
        page: this.page,
        size: this.size,
        sort: [this.sort, this.order].join(",")
      };
      let docStatus = !this.advanceSearchForm.docStatus
        ? [
          constants.OUTGOING_DOC_STATUS.TAOMOI,
          constants.OUTGOING_DOC_STATUS.DANGXULI,
          constants.OUTGOING_DOC_STATUS.CHO_BAN_HANH,
          constants.OUTGOING_DOC_STATUS.TU_CHOI,
          constants.OUTGOING_DOC_STATUS.TU_CHOI_BAN_HANH
        ]
        : [this.advanceSearchForm.docStatus];
      let relationType;
      switch (this.advanceSearchForm.filterStatus) {
        case constants.DU_THAO_PAGE.FILTER.UY_QUYEN:
          relationType = constants.VB_DOC_USER.RELATION_TYPE.NGUOI_UY_QUYEN;
          break;
        case constants.DU_THAO_PAGE.FILTER.PHOI_HOP:
          relationType = constants.VB_DOC_USER.RELATION_TYPE.NGUOI_PHOI_HOP;
          break;
        default:
          relationType = null;
      }
      let status;
      switch (this.advanceSearchForm.filterStatus) {
        case constants.DU_THAO_PAGE.FILTER.CHO_XU_LY:
          status = constants.DOC_USER_STATUS.CHO_XU_LY;
          break;
        case constants.DU_THAO_PAGE.FILTER.DA_XU_LY:
          status = constants.DOC_USER_STATUS.DA_XU_LY;
          break;
        case constants.DU_THAO_PAGE.FILTER.ALL:
        case constants.DU_THAO_PAGE.FILTER.UY_QUYEN:
        default:
          status = -1;
          break;
      }
      let advanceSearchForm = utils.merge(this.advanceSearchForm, {
        docStatus: docStatus,
        relationType: relationType,
        status: status
      });
      return vbOutgoingDocUserViewService
        .findAll2(advanceSearchForm, pageable)
        .then(response => {
          let items = response.data;
          items && (this.outgoingDocs.push(...items));
          return items;
        });
    },

    infiniteHandler($state) {
      this.list().then(items => {
        //console.log(items)
        this.page += 1;
        items && items.length ? $state.loaded() : $state.complete();
      });
    },

    getPiorityClass(id) {
      return constants.HIGH_LEVELS_PIORITY_IDS.indexOf(id) != -1
        ? "lv1"
        : "lv4";
    },

    isShowPriority(id) {
      return constants.HIGH_LEVELS_PIORITY_IDS.indexOf(id) != -1;
    },

    getSecurityClass(id) {
      return constants.HIGH_LEVELS_SECURITY_IDS.indexOf(id) != -1
        ? "lv1"
        : "lv4";
    },

    getStatusLabel(status) {
      switch (status) {
        case constants.OUTGOING_DOC_STATUS.TAOMOI:
          return "Tạo mới";
        case constants.OUTGOING_DOC_STATUS.DABANHANH:
          return "Đã ban hành";
        case constants.OUTGOING_DOC_STATUS.DANGXULI:
          return "Đang trình ký";
        case constants.OUTGOING_DOC_STATUS.CHO_BAN_HANH:
          return "Chờ ban hành";
        case constants.OUTGOING_DOC_STATUS.TU_CHOI:
          return "Đã từ chối";
        case constants.OUTGOING_DOC_STATUS.TU_CHOI_BAN_HANH:
          return "Từ chối ban hành";
        default:
          return status;
      }
    },

    isSeen(event) {
      if (event.hasOwnProperty("isSeen")) {
        if (event.isSeen == 1) return "";
        else return "is-seen";
      } else return "";
    },

    textBold(event) {
      if (event.hasOwnProperty("isSeen")) {
        if (event.isSeen == 1) return "";
        else return "text-bold";
      } else return "";
    },

    viewDetail(item) {
      //console.log(item)
      item.isSeen = 1;
      this.$emit("viewDetail", item);
    }
  }
};



// WEBPACK FOOTER //
// ./src/views/doc-out/mainContentMixin.js